export type BlocklyEventString = [string, string];

export const BLOCKLY_EVENT_STRINGS: BlocklyEventString[] = [
  ["RAGAI.*", "Alle"],
  ["RAGAI.AIIMAGE_OPENAI.CREATE.*", "🖼️ KI-Bild: Alle "],
  ["RAGAI.AIIMAGE_OPENAI.CREATE.start", "🖼️ KI-Bild: Generierung start"],
  ["RAGAI.AIIMAGE_OPENAI.CREATE.done", "🖼️ KI-Bild: Generierung ende"],
  ["RAGAI.AIIMAGE_OPENAI.ANALYZEIMAGE.start", "🖼️ KI-Bild: Analyse start"],
  ["RAGAI.AIIMAGE_OPENAI.ANALYZEIMAGE.done", "🖼️ KI-Bild: Analyse beendet"],
  ["RAGAI.AIIMAGE_FALAI.CREATE.*", "🖼️ KI-Bild (fal.ai): Alle "],
  [
    "RAGAI.AIIMAGE_FALAI.CREATE.start",
    "🖼️ KI-Bild (fal.ai): Generierung start",
  ],
  ["RAGAI.AIIMAGE_FALAI.CREATE.done", "🖼️ KI-Bild (fal.ai): Generierung ende"],
  ["RAGAI.MSG.*", "💬 Nachricht: Alle "],
  ["RAGAI.MSG.runComplete", "💬 Nachricht: Empfang abgeschlossen"],
  ["RAGAI.MSG.prompt", "💬 Nachricht: Prompt wurde geschickt"],
  ["RAGAI.MSG.userMessage", "💬 Nachricht: User Message wurde geschickt"],
  ["RAGAI.MSG.botMessage", "💬 Nachricht: Bot Message wurde geschickt"],
  ["RAGAI.MSG.botBypass", "💬 Nachricht: Bot Bypass wurde geschickt"],
  ["RAGAI.MSG.botBypassComplete", "💬 Nachricht: Bot Bypass erfolgreich"],
  ["RAGAI.MSG.userBypass", "💬 Nachricht: User Bypass wurde geschickt"],
  ["RAGAI.MSG.userBypassComplete", "💬 Nachricht: User Bypass erfolgreich"],
  ["RAGAI.MSG.overwriteSystemPrompt", "💬 System Prompt wurde überschrieben"],
  [
    "RAGAI.MSG.overwriteWebsearchEnabled",
    "💬 Websuche-Aktivierung wurde überschrieben",
  ],
  ["RAGAI.MSG.pasteToPromptInput", "💬 Nutzer kopiert etwas in den Prompt"],

  // ['RAGAI.MSG._addMessagesToThread', 'Nachricht wurde im Thread hinzugefügt'],

  ["RAGAI.EVENTS.LISTENTO", "⚙️ Eventhook wurde registriert"],
  ["RAGAI.AUDIO.SPEECH.*", "🎤 Sprache: Alle"],
  ["RAGAI.AUDIO.SPEECH.micconnected", "🎤 Sprache: Mikrofon verbunden"],
  [
    "RAGAI.AUDIO.SPEECH.repeatlastmessage",
    "🎤 Sprache: Bot wiederholt die letzte Nachricht",
  ],
  ["RAGAI.AUDIO.SPEECH.connecting", "🎤 Sprache: Bot baut die Verbindung auf"],
  [
    "RAGAI.AUDIO.SPEECH.disconnected",
    "🎤 Sprache: Bot hat die Verbindung getrennt",
  ],
  ["RAGAI.AUDIO.SPEECH.thinking", "🎤 Sprache: Bot denkt nach"],
  ["RAGAI.AUDIO.SPEECH.play", "🗣️ Sprache: Bot spricht Start"],
  ["RAGAI.AUDIO.SPEECH.done", "🗣️ Sprache: Bot spricht ende"],
  ["RAGAI.AUDIO.SPEECH.listening", "🗣️ Sprache: Bot ist im Aufnahmemodus"],
  ["RAGAI.AUDIO.SPEECH.recording", "🗣️ Sprache: Bot ist bereit zur Aufnahme"],
  [
    "RAGAI.AUDIO.SPEECH.recordingstopped",
    "🗣️ Sprache: Bot hat die Aufnahme beendet",
  ],
  [
    "RAGAI.AUDIO.SPEECH.attRequest",
    "🗣️ Sprache: User hat Nachricht eingesprochen",
  ],
  [
    "RAGAI.AUDIO.SPEECH.attRecive",
    "🗣️ Sprache: Text der eingesprochenen Nachricht erhalten",
  ],
  ["RAGAI.AUDIO.botSayLoad", "🗣️ Sprache: Stimme wird transkribiert"],
  ["RAGAI.AUDIO.botSayLoadComplete", "🗣️ Sprache: Stimme wurde transkribiert"],
  ["RAGAI.AUDIO.botSayEnded", "🗣️ Sprache: Text wurde zuende vorgelesen"],
  ["RAGAI.AVATAR.SPEECH.thinking", "🧑🏻‍🏫 Avatar: Bot denkt nach"],
  ["RAGAI.AVATAR.SPEECH.play", "🧑🏻‍🏫 Avatar: Spricht Start"],
  ["RAGAI.AVATAR.SPEECH.done", "🧑🏻‍🏫 Avatar: Text wurde zuende vorgelesen"],
  [
    "RAGAI.AVATAR.CONNECTED",
    "🧑🏻‍🏫 Avatar: Verbunden (auch bei jedem erneuten Verbinden)",
  ],
  // NEW AB HIER
  ["RAGAI.OVERLAY.*", "🔲 Overlay: Alle"],
  ["RAGAI.OVERLAY.CLOSE", "🔲 Overlay: Geschlossen"],
  ["RAGAI.OVERLAY.OPEN.*", "🔲 Overlay: Geöffnet"],
  ["RAGAI.OVERLAY.OPEN.text", "🔲 Overlay: Geöffnet (TEXT)"],
  ["RAGAI.OVERLAY.OPEN.html", "🔲 Overlay: Html"],
  ["RAGAI.OVERLAY.OPEN.loading", "🔲 Overlay: Loading"],
  ["RAGAI.OVERLAY.OPEN.textAndButtons", "🔲 Overlay: Geöffnet (Buttons)"],
  [
    "RAGAI.AITEXT_OPENAI.CHATCOMPLETION.*",
    "🗨️ Text: Chat Completion Alle (openai)",
  ],
  [
    "RAGAI.AITEXT_OPENAI.CHATCOMPLETION.request",
    "🗨️ Text: Chat Completion Anfrage gesendet (openai)",
  ],
  [
    "RAGAI.AITEXT_OPENAI.CHATCOMPLETION.result",
    "🗨️ Text: Chat Completion Ergebnis empfangen (openai)",
  ],

  ["RAGAI.ADOBECONNECT.*", "Adobe Connect: Alle"],
  ["RAGAI.ADOBECONNECT.connected", "Adobe Connect: Bot verbunden"],
  ["RAGAI.ADOBECONNECT.rolechanged", "Adobe Connect: Rolle geändert"],
  [
    "RAGAI.ADOBECONNECT.selectedlayoutchanged",
    "Adobe Connect: Layout ausgewählt",
  ],
  ["RAGAI.ADOBECONNECT.userjoined", "Adobe Connect: Nutzer ist beigetreten"],
  ["RAGAI.ADOBECONNECT.userleft", "Adobe Connect: Nutzer hat Raum verlassen"],
  [
    "RAGAI.ADOBECONNECT.userstatuschanged",
    "Adobe Connect: Nutzerstatus geändert",
  ],
  [
    "RAGAI.ADOBECONNECT.playstatechanged",
    "Adobe Connect: Recordingstatus geändert (play, pause)",
  ],
  [
    "RAGAI.ADOBECONNECT.podtitlechanged",
    "Adobe Connect: Titel des Pods geändert",
  ],
  ["RAGAI.ADOBECONNECT.sizechanged", "Adobe Connect: Größe des Pods geändert"],
  [
    "RAGAI.ADOBECONNECT.userdetailschanged",
    "Adobe Connect: Nutzerdetails geändert",
  ],
  [
    "RAGAI.ADOBECONNECT.syncmessagereceived",
    "Adobe Connect: Syncnachricht empfangen",
  ],

  ["RAGAI.WEBHOOK.*", "⚓️ WEBHOOK: Alle"],
  ["RAGAI.WEBHOOK.CALL.request", "⚓️ WEBHOOK: Anfrage gesendet"],
  ["RAGAI.WEBHOOK.CALL.result", "⚓️ WEBHOOK: Ergebnis empfangen"],
  ["RAGAI.MAIL.*", "📧 Mail: Alle"],
  ["RAGAI.MAIL.WEBHOOK.send", "📧 Mail: senden via Webhook"],
  ["RAGAI.MAIL.WEBHOOK.done", "📧 Mail: gesendet via Webhook"],

  ["RAGAI.BUTTON.CLICK", "Button: Click"],

  ["RAGAI.VIMEO.*", "Vimeo: Alle"],
  ["RAGAI.VIMEO.playerready", "Vimeo: Bereit"],
  ["RAGAI.VIMEO.PLAY", "Vimeo: Abspielen"],
  ["RAGAI.VIMEO.PAUSE", "Vimeo: Pause"],
  ["RAGAI.VIMEO.playpositionchanged", "Vimeo: Wiedergabeposition geändert"],
  ["RAGAI.VIMEO.CURRENTPLAYPOSITION", "Vimeo: Ton aus"],
  ["RAGAI.VIMEO.GETCOLORS", "Vimeo: Farbe geholt"],
  ["RAGAI.VIMEO.SETCOLORS", "Vimeo: Farbe gesetzt"],
  ["RAGAI.VIMEO.SETPLAYBACKRATE", "Vimeo: Wiedergabegeschwindigkeit"],
  ["RAGAI.VIMEO.SETVOLUME", "Vimeo: Lautstärke"],
  ["RAGAI.VIMEO.SEEKTO", "Vimeo: Springe zu"],
  ["RAGAI.VIMEO.LOADVIDEO", "Vimeo: Videowechsel"],

  ["RAGAI.YOUTUBE.*", "Youtube: Alle"],
  ["RAGAI.YOUTUBE.playerready", "Youtube: Bereit"],
  ["RAGAI.YOUTUBE.PLAY", "Youtube: Abspielen"],
  ["RAGAI.YOUTUBE.PAUSE", "Youtube: Pause"],
  ["RAGAI.YOUTUBE.STOP", "Youtube: Stoppen"],
  ["RAGAI.YOUTUBE.MUTE", "Youtube: Ton aus"],
  ["RAGAI.YOUTUBE.UNMUTE", "Youtube: Ton ein"],
  ["RAGAI.YOUTUBE.SETPLAYBACKRATE", "Youtube: Wiedergabegeschwindigkeit"],
  ["RAGAI.YOUTUBE.SETVOLUME", "Youtube: Lautstärke"],
  ["RAGAI.YOUTUBE.SEEKTO", "Youtube: Springe zu"],
  ["RAGAI.YOUTUBE.CHANGEVIDEO", "Youtube: Videowechsel"],

  ["RAGAI.RISE.*", "Rise: Alle"],
  ["RAGAI.RISE.init", "Rise: Bereit"],
  ["RAGAI.RISE.click", "Rise: Klick"],
  ["RAGAI.RISE.ANSWER", "Rise: Nutzerantwort"],
  ["RAGAI.RISE.ANSWER.correct", "Rise: Nutzerantwort war richtig"],
  ["RAGAI.RISE.ANSWER.incorrect", "Rise: Nutzerantwort war falsch"],
  ["RAGAI.RISE.pagechange", "Rise: Seitenposition geändert"],

  ["RAGAI.LXT.*", "LXT: Alle"],
  ["RAGAI.LXT.init", "LXT: Bereit"],
  ["RAGAI.LXT.click", "LXT: Klick"],
  ["RAGAI.LXT.ANSWER", "LXT: Nutzerantwort"],
  ["RAGAI.LXT.ANSWER.correct", "LXT: Nutzerantwort war richtig"],
  ["RAGAI.LXT.ANSWER.incorrect", "LXT: Nutzerantwort war falsch"],
  ["RAGAI.LXT.pagechange", "LXT: Seitenposition geändert"],

  ["RAGAI.SCORM.*", "SCORM: Alle"],
  ["RAGAI.SCORM.INITED", "SCORM: Initialisiert"],

  ["RAGAI.STAGE.*", "Stage: Alle"],
  ["RAGAI.STAGE.ENTER", "Stage: Betreten"],
  ["RAGAI.STAGE.EXIT", "Stage: Verlassen"],
  ["RAGAI.STAGE.CHANGED", "Stage: Geändert"],

  ["RAGAI.KEYVAL.*", "🔑 KeyVal: Alle"],
  ["RAGAI.KEYVAL.waitForInit", "🔑 KeyVal: Bereit"],
  ["RAGAI.KEYVAL.deleteKeyValEntry", "🔑 KeyVal: Gelöscht"],
  ["RAGAI.KEYVAL.storeKeyValEntry", "🔑 KeyVal: Gespeichert"],
  ["RAGAI.KEYVAL.getKeyValEntry", "🔑 KeyVal: Hole Eintrag"],
  ["RAGAI.KEYVAL.getKeyValByType", "🔑 KeyVal: Hole Einträge nach Typ"],

  ["RAGAI.PROJECTKEYVAL.*", "🔑 Projekt-KeyVal: Alle"],
  ["RAGAI.PROJECTKEYVAL.waitForInit", "🔑 Projekt-KeyVal: Bereit"],
  ["RAGAI.PROJECTKEYVAL.deleteKeyValEntry", "🔑 Projekt-KeyVal: Gelöscht"],
  ["RAGAI.PROJECTKEYVAL.storeKeyValEntry", "🔑 Projekt-KeyVal: Gespeichert"],
  ["RAGAI.PROJECTKEYVAL.getKeyValEntry", "🔑 Projekt-KeyVal: Hole Eintrag"],
  [
    "RAGAI.PROJECTKEYVAL.getKeyValByType",
    "🔑 Projekt-KeyVal: Hole Einträge nach Typ",
  ],
  ["RAGAI.PROJECTKEYVAL.remoteUpdate", "🔑 Projekt-KeyVal: Remote Änderung"],
  ["RAGAI.PROJECTKEYVAL.remoteDelete", "🔑 Projekt-KeyVal: Remote Löschung"],

  ["RAGAI.INFO.disconnected", "Info: Verbindung zum Bot verloren"],

  ["RAGAI.FLOW.*", "🚀 Flow: Alle"],
  ["RAGAI.FLOW.ready", "🚀 Flow: Bot ist bereit"],
  ["RAGAI.FLOW.firstUserMessage", "🚀 Flow: Erste Nutzernachricht"],
  ["RAGAI.FLOW.firstBotResponse", "🚀 Flow: Erste Bot-Antwort"],
  ["RAGAI.FLOW.requestStart", "🚀 Flow: Anfrage gestartet"],
  ["RAGAI.FLOW.requestComplete", "🚀 Flow: Antwort abgeschlossen"],
];

export function getBlocklyEventStrings(
  startsWith?: string,
): BlocklyEventString[] {
  if (!startsWith) return BLOCKLY_EVENT_STRINGS;
  return BLOCKLY_EVENT_STRINGS.filter(([key, _]) => key.startsWith(startsWith));
}

export function getRawBlocklyEventStrings(
  startsWith?: string,
): BlocklyEventString[] {
  return getBlocklyEventStrings(startsWith).map(([key, _]) => [key, key]);
}
